import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';

interface AuthState {
    nameidentifier: string | null;
    sub: string | null;
    email: string | null;
    jti: string | null;
    ContactNo: string | null;
    token: string | null;
    isAuthenticated: boolean;
}

const storedToken = localStorage.getItem('token');

let initialState: AuthState = {
    nameidentifier: null,
    sub: null,
    email: null,
    jti: null,
    ContactNo: null,
    token: storedToken,
    isAuthenticated: false,
};

if (storedToken) {
    try {
        const decodedToken: any = jwtDecode(storedToken);
        initialState = {
            ...initialState,
            nameidentifier: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
            sub: decodedToken['sub'],
            email: decodedToken['email'],
            jti: decodedToken['jti'],
            ContactNo: decodedToken['ContactNo'],
            isAuthenticated: true,
        };
    } catch (error) {
        console.error('Token decoding failed', error);
    }
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUserData: (state, action: PayloadAction<any>) => {
            const { nameidentifier, sub, email, jti, ContactNo, token } = action.payload;
            state.nameidentifier = nameidentifier;
            state.sub = sub;
            state.email = email;
            state.jti = jti;
            state.ContactNo = ContactNo;
            state.token = token;
            state.isAuthenticated = true;

            // Store token in localStorage
            localStorage.setItem('token', token);
        },
        logout: (state) => {
            state.nameidentifier = null;
            state.sub = null;
            state.email = null;
            state.jti = null;
            state.ContactNo = null;
            state.token = null;
            state.isAuthenticated = false;
            localStorage.removeItem('token');
        },
    },
});

export const { setUserData, logout } = authSlice.actions;

export default authSlice.reducer;
